import { render, staticRenderFns } from "./dialog-alert-with-inner-icon.mpx?vue&type=template&id=4674eb6a&isComponent&outputPath=components%2Fdialog-alert-with-inner-icon7c4b25da%2Findex"
import script from "./dialog-alert-with-inner-icon.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdialog-alert-with-inner-icon7c4b25da%2Findex"
export * from "./dialog-alert-with-inner-icon.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdialog-alert-with-inner-icon7c4b25da%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports